<template>
  <div class="helper">
    <!-- 数字名片介绍  stat -->
    <common-carousel :carouselData="carouselData" />

    <div class="container" style="padding-top: 100px">
      <div class="container-header">
        <img
          class="container-leftTitle"
          :src="`${this.$baseImgUrl}images/leftTitle.png`"
          alt=""
        />
        <span class="container-title"
          >六大优势 <span class="container-dot"></span>助力门店轻松管理</span
        >
        <img
          class="container-rightTitle"
          :src="`${this.$baseImgUrl}images/rightTitle.png`"
          alt=""
        />
      </div>
      <div class="container-content">
        <el-row :gutter="75">
          <el-col
            :span="8"
            v-for="(item, index) in headerList"
            :key="`hd${index}`"
            style="margin-bottom: 70px"
          >
            <observer @on-change="upwardOnChange" :threshold="threshold">
              <el-card
                class="business-card flex-display flex-display-column flex-center-align"
                :body-style="{ padding: '0px' }"
                :class="[
                  { 'visible-content': visibleContent },
                  index >= 3 ? ' animation-10 animation-upward' : '',
                ]"
              >
                <div class="img-frame flex-display flex-center-pack">
                  <img class="img" :src="item.img" alt="" />
                </div>
                <div style="margin-top: 20px; text-align: center">
                  <div class="title">{{ item.title }}</div>
                  <div class="sub-title">{{ item.subTitle }}</div>
                </div>
              </el-card>
            </observer>
          </el-col>
        </el-row>

        <!-- 数字名片介绍  end -->
      </div>
    </div>

    <div class="helper-main">
      <div
        class="main-item"
        :class="{ 'default-theme': item.key % 2 == 1 }"
        v-for="item in mainList"
        :key="item.key"
      >
        <observer @on-change="rightOnChangeOne" :threshold="threshold">
          <div class="item flex-display">
            <template v-if="item.key % 2 == 1">
              <div class="img-frame">
                <img :src="item.img" alt="" />
              </div>
              <div class="text-frame flex-display flex-center-align">
                <div class="text-content flex-display flex-display-column">
                  <span class="title">{{ item.title }}</span>
                  <span class="sub-title">{{ item.subTitle }}</span>
                </div>
              </div>
            </template>

            <template v-if="item.key % 2 == 0">
              <div class="text-frame flex-display flex-center-align">
                <div class="text-content flex-display flex-display-column">
                  <span class="title">{{ item.title }}</span>
                  <span class="sub-title">{{ item.subTitle }}</span>
                </div>
              </div>
              <div class="img-frame"><img :src="item.img" alt="" /></div>
            </template>
          </div>
        </observer>
      </div>
    </div>

    <div class="qr-code-footer flex-display flex-right-align">
      <div class="footer-bg-frame flex-display flex-center-pack">
        <img
          :src="`${$baseImgUrl}images/business-card-footer-bg.png`"
          class="footer-bg"
          alt=""
        />
        <div class="container flex-display flex-center-pack">
          <div class="left flex-display flex-center-align">
            <span class="text">扫描二维码</span>
            <span class="text">体验更多数字名片功能</span>
          </div>
          <img
            v-if="webType === 0"
            src="https://cdn-oss.kabel.work/scheme/20220705/4233d205-8fda-4119-802f-27a894ab7e98.jpg"
            class="qr-code"
            alt=""
          />
          <img
            v-if="webType === 1"
            src="https://cdn-oss.kabel.work/website/images/helper-footer-qr-code.png"
            class="qr-code"
            alt=""
            style="border-radius: 50%;"
          />
            <!-- src="https://cdn-oss.kabel.work/scheme/20220704/d6c45329-b26b-4ad2-b039-7e1374e4a223.jpg" -->
          <div class="right flex-display flex-display-column flex-center-pack">
            <span class="title">{{webType === 0 ? '派加' : webType === 1 ? '卡百利' : ''}}门店助手</span>
            <span class="sub-title">微信小程序</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonCarousel from '@/components/common/carousel'
import Observer from '@/components/index.js'

export default {
  components: {
    commonCarousel, Observer
  },
  name: 'Helper',
  data () {
    return {
      threshold: [1], // [0, 0.25, 0.5, 0.75, 1] 1：元素百分百滑动到可见区域时
      visibleContent: false, // 显示-向上的动画效果
      carouselData: [
        {
          title: '派加门店助手',
          subTitle: '让门店管理无忧',
          icon: `https://cdn-oss.kabel.work/scheme/20220705/c88733c1-5a56-478c-8db1-fe93e2e923fd.jpeg`,
          rightImg: `${this.$baseImgUrl}images/helper-slideshowRight-1.png`,
          url: `${this.$baseImgUrl}images/helper-slideshow-1.png`,
          video: `${this.$baseImgUrl}videos/3-workbench.mp4`
        }
      ],
      headerList: [
        {
          title: '统一管理客户',

          img: `${this.$baseImgUrl}images/helper-header-1.png`,
          subTitle: '老客户/新客户/成交客户、广告客户、营销客户、官网客户'
        },
        {
          title: '提醒功能',
          img: `${this.$baseImgUrl}images/helper-header-2.png`,
          subTitle: '阶段款到期自动提醒；长尾客户定时提醒（7天）'
        },
        {
          title: '装修日记',
          img: `${this.$baseImgUrl}images/helper-header-3.png`,
          subTitle: '店员绩效管理；施工规范化管理；装修日记一键转装修案例；'
        },

        {
          title: '云电话',
          img: `${this.$baseImgUrl}images/helper-header-4.png`,
          subTitle: '号码地域可选，全程录音和质检通话时长统计、录音回放, 将冠军经验全员推广'
        },

        {
          title: '离职继承',
          img: `${this.$baseImgUrl}images/helper-header-5.png`,
          subTitle: '成员离职后，店长可将他的客户分配给其他成员跟进，避免员工离职造成门店客户流失'
        },
        {
          title: '店长数据看板',
          img: `${this.$baseImgUrl}images/helper-header-6.png`,
          subTitle: '数据简报、新增线索趋势、线索转化趋势、跟进阶段漏斗、TOP排行榜'
        }

      ],
      mainList: [{
        key: 1,
        img: `${this.$baseImgUrl}images/helper-one.png`,
        title: '客户统一管理',
        subTitle: '老客户/新客户/成交客户，统一管理',
        index: 'One'

      },

      {
        key: 2,
        img: `${this.$baseImgUrl}images/helper-two.png`,
        title: '随手掌握',
        subTitle: '员工功劳苦劳，老板随手掌握',
        index: 'Two'

      },
      {
        key: 3,
        img: `${this.$baseImgUrl}images/helper-three.png`,
        title: '系统管理',
        subTitle: '客户回款，施工进度，均有系统进行管理',
        index: 'Three'

      }]
    }
  },
  mounted () {
    // 监听滚动条
  },
  created() {
    // 如果是派加
    if (this.webType === 0) {
      this.carouselData[0].title = '派加门店助手'
      this.carouselData[0].icon = 'https://cdn-oss.kabel.work/scheme/20220705/c88733c1-5a56-478c-8db1-fe93e2e923fd.jpeg'
    } else if (this.webType === 1) {
      this.carouselData[0].title = '卡百利门店助手'
      this.carouselData[0].icon = 'https://cdn-oss.kabel.work/website/images/helper-slideshowIcon-1.png'
    }
    
  },
  methods: {
    goKabelShop () {
      window.open(this.href, '_blank') // 在新窗口打开外链接
    },
    upwardOnChange (entry) {
      // 向上-动画
      if (!this.visibleContent) {
        this.visibleContent = entry.isIntersecting
      }
    },
    rightOnChangeOne (entry) {
      console.log(1)
    },
    rightOnChangeTwo (entry) {
      console.log(2)
    },
    rightOnChangeThree (entry) {
      console.log(3)
    }

  }
}
</script>
<style lang="less" scoped>
.helper {
  margin-top: 70px;
}
.container-header {
  text-align: center;
}
.container-title {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 45px;
}
.container-dot {
  width: 6px;
  height: 6px;
  margin: 0 10px;
  display: inline-block;
  background: rgb(38, 110, 236);
  position: relative;
  left: -4px;
  top: -6px;
}
.container-leftTitle {
  padding-right: 20px;
}
.container-rightTitle {
  padding-left: 20px;
}
.container-content {
  padding-top: 60px;
  padding-bottom: 30px;
}
.business-card {
  height: 380px;
  .img-frame {
    width: 100%;
    padding: 35px 0;
    .img {
      width: 137px;
      height: 137px;
    }
  }
  .title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 33px;
    margin-bottom: 15px;
  }
  .sub-title {
    width: 250px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
  }
}

// 头部END

.helper-main {
  // padding-bottom: 100px;
  .main-item {
    height: 700px;
    background: #fff;
    .item {
      width: 1360px;
      margin: 0 auto;
      .img-frame {
        width: 700px;
        height: 700px;
      }
      .text-frame {
        flex: 1;
        height: 700px;
        padding-left: 100px;
        .title {
          margin-bottom: 40px;
          font-size: 40px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: bold;
          color: #333333;
          line-height: 60px;
        }
        .sub-title {
          width: 380px;
          font-size: 20px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #666666;
          line-height: 40px;
        }
      }
    }
  }
  .default-theme {
    background: #f5f8fe;
  }
}
.helper-footer {
  width: 100%;
  background-size: 100% 100%;
  .container {
    height: 100%;
    // padding-left: 89px;
    // padding-right: 68px;
    box-sizing: border-box;

    .left {
      margin-right: 207px;
      .text {
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 42px;
      }
      .text:nth-child(1) {
        margin-right: 20px;
      }
    }
    .search-frame {
      position: relative;
      .input {
        width: 465px;
        height: 60px;
        outline: none;
        padding: 0 33px;
        border: none;
        background: #ffffff;
        box-shadow: 0px 10px 20px 0px rgba(220, 90, 24, 0.25);
        border-radius: 31px;
        .input-text {
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #e2b282;
          line-height: 28px;
        }
      }
      .icon {
        position: absolute;
        width: 99px;
        height: 50px;
        right: 5px;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
  }
}

// 动画-上
.animation-upward {
  opacity: 0;
  transform: translateY(50px);
  transform: translateY(50px);
  -ms-transform: translateY(50px);
  -moz-transform: translateY(50px);
  -webkit-transform: translateY(50px);
  -o-transform: translateY(50px);
}

.visible-content.animation-upward {
  transform: translateY(0);
  transform: translateY(0);
  -ms-transform: translateY(0);
  -moz-transform: translateY(0);
  -webkit-transform: translateY(0);
  -o-transform: translateY(0);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/helper.vue